import { WarningAltFilled } from "@carbon/icons-react";
import i18next from "../../../i18n";

const NetworkError = ({
  title,
  message,
}: {
  title?: string;
  message?: string;
}) => {
  return (
    <div className="flex gap-2 items-center p-6 rounded-md border-2 border-red-500 bg-red-100">
      <WarningAltFilled size={32} className="text-red-700" />
      <div>
        <h2 className="text-lg font-semibold uppercase">
          {title || i18next.t("global.networkError")}
        </h2>
        <p className="text-gray-700 text-xs">
          {message || i18next.t("global.networkErrorMessage")}
        </p>
      </div>
    </div>
  );
};

export default NetworkError;
